import { ProductType } from "@repo/api";
import { useDpsMigrationBanner } from "@repo/logic";
import { PensionDpsMigrationBanner } from "@repo/ui";
import { type FC, useMemo } from "react";
import { useContracts, usePensionDetail } from "../../queryHooks";

export const PensionDpsMigrationBannerWrapper: FC = () => {
    const contractsQuery = useContracts();

    // the banner is rendered on the contracts listing page where no ContractIDProvider exists
    // => cannot use useContractId().
    const pfContract = useMemo(
        () => contractsQuery.data?.find((c) => c.type === ProductType.Pf),
        [contractsQuery.data],
    );
    const pfContractId = pfContract?.id ?? "";

    const pensionDetailQuery = usePensionDetail({
        id: pfContractId,
        type: ProductType.Pf,
        options: { enabled: Boolean(pfContractId) },
    });

    const { showBanner } = useDpsMigrationBanner(contractsQuery, pensionDetailQuery);

    if (!showBanner) return null;

    return <PensionDpsMigrationBanner />;
};
